const played = document.querySelectorAll('.matches-item[data-played]');
const future = document.querySelectorAll('.matches-item[data-future]');
const home = document.querySelectorAll('.matches-item[data-home]');
const away = document.querySelectorAll('.matches-item[data-away]');
const matches = document.querySelectorAll('.matches-item');
const swappers = document.querySelectorAll('button[data-matches-type]');

const show = (match) => {
    match.style.cssText = 'display: flex;';
};

const hide = (match) => {
    match.style.cssText = 'display: none !important;';
};

/**
 * Hides matches based on type
 * @param {String} type
 */
const swapMatches = (type) => {
    if (type === 'all') {
        matches.forEach(show);
        return;
    }
    matches.forEach(hide);
    switch (type) {
        case 'played':
            played.forEach(show);
            break;
        case 'future':
            future.forEach(show);
            break;
        case 'home':
            home.forEach(show);
            break;
        case 'away':
            away.forEach(show);
            break;
    }
};

/**
 * Hightlights clicked swapper
 * @param {Event} e
 */
const highlightSwapper = (e) => {
    swappers.forEach((swapper) => {
        swapper.classList.remove('fw-bold');
        swapper.classList.add('fw-normal');
    });
    e.currentTarget.classList.add('fw-bold');
    e.currentTarget.classList.remove('fw-normal');
};

/**
 * Handles swapper click
 * @param {Event} e
 */
const handleSwapperClick = (e) => {
    const type = e.currentTarget.getAttribute('data-matches-type');
    highlightSwapper(e);
    swapMatches(type);
};

/**
 * Inits swappers
 * @param {Element} swapper
 */
const init = (swapper) => {
    swapper.addEventListener('click', (e) => {
        handleSwapperClick(e);
    });
};

swappers.forEach(init);
